// extracted by mini-css-extract-plugin
export default {"card":"_JhVRIIJ","header":"iwA2o3cf","title":"q8O8bxO0","label":"VMDtr1QA","name":"kdHMZV_e","buttons":"qbSEUF0J","form":"wZukVcQl","ant-form-item-label":"EVnSMoR2"};